import useCoreModelsFindAll from '../../../hooks/useCoreModelsFindAll'

export default (query, opts) => useCoreModelsFindAll('scheduleTimelog', query, opts)
